const hostOf = (url) => {
  try {
    return url ? new URL(url).host.toLowerCase() || null : null;
  } catch {
    return null;
  }
};

const param = (search, name) => {
  try {
    const value = new URLSearchParams(search || "").get(name);
    return value ? value.slice(0, 64) : null;
  } catch {
    return null;
  }
};

export const readEntry = (win = typeof window !== "undefined" ? window : null) => {
  if (!win) return null;
  try {
    const { location, document } = win;
    return {
      referrer: hostOf(document && document.referrer),
      utmSource: param(location.search, "utm_source"),
      utmMedium: param(location.search, "utm_medium"),
      path: location.pathname,
    };
  } catch {
    return null;
  }
};

const LANDING = readEntry();

export const getLandingEntry = () => LANDING;

const hasSignal = (entry) =>
  Boolean(entry && (entry.referrer || entry.utmSource || entry.utmMedium));

const withoutPath = (entry) => {
  if (!entry) return null;
  const { path, ...rest } = entry;
  return Object.fromEntries(Object.entries(rest).filter(([, v]) => v));
};

export const contactEntry = (landing = getLandingEntry()) =>
  hasSignal(landing) ? withoutPath(landing) : undefined;

export const buildViewEntry = ({
  landedHere,
  pathname,
  landing = getLandingEntry(),
  current = readEntry(),
} = {}) => {
  if (landedHere) return withoutPath(current);
  if (landing && hasSignal(landing) && landing.path === pathname) {
    return withoutPath(landing);
  }
  return { inApp: true };
};

const currentPath = () => {
  try {
    return window.location.pathname;
  } catch {
    return null;
  }
};

export const buildImpressionEntry = (landing = getLandingEntry(), pathname = currentPath()) =>
  hasSignal(landing) && landing.path === pathname ? withoutPath(landing) : { inApp: true };
